module.exports = __webpack_public_path__ + "static/img/08.eb0e486.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour5/08.jpg
// module id = Ne9/
// module chunks = 0